import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsPillsComponent } from '../materials-pills/materials-pills.component';
import { Material } from '../../../types/material.interface';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-modal-materials-section',
  standalone: true,
  imports: [
    CommonModule,
    MaterialsPillsComponent,
    TranslatePipe
  ],
  templateUrl: './modal-materials-section.component.html',
  styleUrl: './modal-materials-section.component.scss'
})
export class ModalMaterialsSectionComponent {
  @Input() set materialInput(value: Material[]) {
    this._materialInput.set(value || []);
  }

  @Input() set materialOutput(value: Material[]) {
    this._materialOutput.set(value || []);
  }

  @Input() inputTitle: string = 'modalMaterials.materialsReceived';
  @Input() outputTitle: string = 'modalMaterials.materialsDelivered';
  @Input() pillSize: 'sm' | 'md' | 'lg' | 'xl' = 'md';

  private _materialInput = signal<Material[]>([]);
  private _materialOutput = signal<Material[]>([]);

  readonly hasInputMaterials = computed(() => this._materialInput().length > 0);
  readonly hasOutputMaterials = computed(() => this._materialOutput().length > 0);
  readonly inputMaterials = computed(() => this._materialInput());
  readonly outputMaterials = computed(() => this._materialOutput());
  readonly hasAnyMaterials = computed(() => this.hasInputMaterials() || this.hasOutputMaterials());
}
